module.exports = __webpack_public_path__ + "img/single-img-1_1single-img-1.740e44f0.png";